// A server seed is keyed by its UTC day (`YYYY-MM-DD`), while the shared Calendar draws and
// returns local-midnight dates. These convert between the two by the date's own components, so
// the day a shopper clicks is the day that is looked up, in every time zone.

const DAY_MS = 86_400_000;

/** The UTC day key `offsetDays` from `now`: 0 is today's seed, 1 the one committed for tomorrow. */
export function utcDayKey(now: Date, offsetDays = 0): string {
  return new Date(now.getTime() + offsetDays * DAY_MS).toISOString().slice(0, 10);
}

/** A day key as the local-midnight date whose calendar cell carries the same numbers. */
export function dayKeyToCalendarDate(key: string): Date {
  const [year = 0, month = 1, day = 1] = key.split("-").map(Number);
  return new Date(year, month - 1, day);
}

/** A calendar cell's date back to its day key. Never `toISOString`, which shifts the day east of UTC. */
export function calendarDateToDayKey(date: Date): string {
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${date.getFullYear()}-${month}-${day}`;
}
